module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-ExtraBold-Italic.06485329.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-ExtraBold-Italic.otf
// module id = 2189
// module chunks = 53